import React from 'react';

import { getServiceName } from '@repo/utils';
import cn from 'classnames';

import { IConDefaultType } from '../types';

export enum CoinIconVariant {
  DEFAULT = 'default',
  NON_SHADE = 'non_shade',
  DISABLED = 'disabled',
}

interface ICoinIconProps extends IConDefaultType {
  variant?: CoinIconVariant;
}

function CoinIcon({ className, size = 24, rotate, flip, variant = CoinIconVariant.DEFAULT }: ICoinIconProps) {
  const uniqueId = React.useId();
  const serviceName = getServiceName() as 'bubblechat' | 'tingle';

  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === CoinIconVariant.DEFAULT && serviceName === 'bubblechat' && (
        <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15" cy="15" r="12.5" fill={`url(#paint0_linear_${uniqueId})`} />
          <path
            d="M19.0101 13.5413C18.2047 13.5413 17.5518 14.1942 17.5518 14.9996C17.5518 15.805 18.2047 16.4579 19.0101 16.4579C19.8155 16.4579 20.4684 15.805 20.4684 14.9996C20.4684 14.1942 19.8155 13.5413 19.0101 13.5413Z"
            fill={`url(#paint1_linear_${uniqueId})`}
          />
          <path
            d="M10.9896 13.5413C10.1842 13.5413 9.53125 14.1942 9.53125 14.9996C9.53125 15.805 10.1842 16.4579 10.9896 16.4579C11.795 16.4579 12.4479 15.805 12.4479 14.9996C12.4479 14.1942 11.795 13.5413 10.9896 13.5413Z"
            fill={`url(#paint2_linear_${uniqueId})`}
          />
          <path
            d="M16.8226 15H13.1768L13.2062 15.5656C13.2962 16.432 14.0755 17.0833 15.011 17.0833C16.0114 17.0833 16.8226 16.3416 16.8226 15.4269V15Z"
            fill={`url(#paint3_linear_${uniqueId})`}
          />
          <path
            d="M16.4995 15.323C16.4995 16.1512 15.8277 16.8228 14.9995 16.823C14.1712 16.823 13.4995 16.1513 13.4995 15.323H16.4995ZM10.9956 13.8748C11.6321 13.8748 12.1487 14.3907 12.1489 15.0271C12.1489 15.6637 11.6322 16.1794 10.9956 16.1794C10.3592 16.1792 9.84329 15.6636 9.84326 15.0271C9.84349 14.3908 10.3593 13.875 10.9956 13.8748ZM19.022 13.8748C19.6585 13.8748 20.1751 14.3907 20.1753 15.0271C20.1753 15.6637 19.6586 16.1794 19.022 16.1794C18.3855 16.1793 17.8697 15.6636 17.8696 15.0271C17.8699 14.3908 18.3856 13.8749 19.022 13.8748Z"
            fill="#CC6B12"
          />
          <path
            d="M15 5.625C20.1694 5.625 24.375 9.83068 24.375 15C24.3749 20.1693 20.1693 24.375 15 24.375C13.5102 24.375 12.082 24.0333 10.7637 23.3623C10.6499 23.3165 10.5479 23.295 10.4395 23.2949C10.2914 23.2949 10.122 23.3337 9.87793 23.4238L9.75 23.4727L9.46094 23.5938L8.61816 23.9619C8.51683 24.0018 8.40961 24.0283 8.30859 24.0283C7.91653 24.0283 7.59149 23.7342 7.54395 23.3496L7.53809 23.251L7.54395 23.1797L7.57617 23.0068L7.72852 22.2217L7.78027 21.9365L7.81543 21.7031L7.83496 21.5195L7.83887 21.3652C7.83682 21.2801 7.82616 21.2085 7.80566 21.1396L7.76758 21.0371L7.71094 20.9258L7.64355 20.8086C6.32281 19.1384 5.62503 17.1298 5.625 15C5.625 9.83068 9.83059 5.625 15 5.625ZM15 6.66699C10.4059 6.66699 6.66602 10.406 6.66602 15C6.66604 16.7768 7.21066 18.4527 8.24707 19.8799L8.46094 20.1621L8.54688 20.2891L8.64062 20.4561L8.69727 20.5674L8.74219 20.6719L8.80371 20.8428C8.8397 20.9638 8.86239 21.0858 8.87305 21.2354L8.87988 21.3945L8.87207 21.6133L8.84473 21.8594L8.80469 22.1201L8.75098 22.4209L8.67676 22.7979L9.05957 22.6318L9.37598 22.501L9.5166 22.4463C9.86574 22.3174 10.1464 22.253 10.4385 22.2529C10.6849 22.2529 10.919 22.3015 11.2363 22.4336C12.4088 23.0303 13.6752 23.333 15 23.333C19.5938 23.3328 23.3329 19.5939 23.333 15C23.333 10.4061 19.5939 6.6672 15 6.66699Z"
            fill={`url(#paint4_linear_${uniqueId})`}
          />
          <path
            opacity="0.351577"
            d="M15 2.5C21.9036 2.5 27.5 8.09644 27.5 15C27.5 21.9036 21.9036 27.5 15 27.5C8.09644 27.5 2.5 21.9036 2.5 15C2.5 8.09644 8.09644 2.5 15 2.5ZM15 3.02051C8.3841 3.02051 3.02052 8.3841 3.02051 15C3.02051 21.6159 8.38409 26.9795 15 26.9795C21.6159 26.9794 26.9795 21.6159 26.9795 15C26.9795 8.38415 21.6158 3.02058 15 3.02051Z"
            fill="#FFB649"
          />
          <defs>
            <linearGradient
              id={`paint0_linear_${uniqueId}`}
              x1="2.5"
              y1="2.5"
              x2="2.5"
              y2="27.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FCF041" />
              <stop offset="0.865851" stopColor="#F1A503" />
              <stop offset="1" stopColor="#F1CF03" />
            </linearGradient>
            <linearGradient
              id={`paint1_linear_${uniqueId}`}
              x1="19.0101"
              y1="13.5413"
              x2="19.0101"
              y2="16.4579"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#CD8700" />
              <stop offset="1" stopColor="#FFEF00" />
            </linearGradient>
            <linearGradient
              id={`paint2_linear_${uniqueId}`}
              x1="10.9896"
              y1="13.5413"
              x2="10.9896"
              y2="16.4579"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#CD8700" />
              <stop offset="1" stopColor="#FFEF00" />
            </linearGradient>
            <linearGradient
              id={`paint3_linear_${uniqueId}`}
              x1="17.1479"
              y1="17.2921"
              x2="17.1479"
              y2="14.837"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFEF00" />
              <stop offset="1" stopColor="#CD8700" />
            </linearGradient>
            <linearGradient
              id={`paint4_linear_${uniqueId}`}
              x1="24.9279"
              y1="24.0985"
              x2="24.9279"
              y2="8.75"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFEF00" />
              <stop offset="1" stopColor="#CC6B12" />
            </linearGradient>
          </defs>
        </svg>
      )}
      {variant === CoinIconVariant.DEFAULT && serviceName === 'tingle' && (
        <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M27.5 15C27.5 21.9036 21.9036 27.5 15 27.5C8.09644 27.5 2.5 21.9036 2.5 15C2.5 8.09644 8.09644 2.5 15 2.5C21.9036 2.5 27.5 8.09644 27.5 15Z"
            fill={`url(#paint0_linear_${uniqueId})`}
          />
          <path
            d="M26.7505 15C26.7505 8.51065 21.4893 3.24951 15 3.24951C8.51065 3.24951 3.24951 8.51065 3.24951 15C3.24951 21.4893 8.51065 26.7505 15 26.7505V27.5C8.09644 27.5 2.5 21.9036 2.5 15C2.5 8.09644 8.09644 2.5 15 2.5C21.9036 2.5 27.5 8.09644 27.5 15C27.5 21.9036 21.9036 27.5 15 27.5V26.7505C21.4893 26.7505 26.7505 21.4893 26.7505 15Z"
            fill="#673F00"
          />
          <path
            d="M25 15C25 20.5228 20.5228 25 15 25C9.47715 25 5 20.5228 5 15C5 9.47715 9.47715 5 15 5C20.5228 5 25 9.47715 25 15Z"
            fill={`url(#paint1_linear_${uniqueId})`}
          />
          <path
            d="M15.8289 9.375C16.699 9.37507 17.4908 9.55144 18.1873 9.92188L18.1885 9.92065C18.8831 10.2822 19.4333 10.8022 19.8267 11.4722L19.967 11.7285C20.2701 12.3362 20.415 13.0161 20.415 13.7537C20.415 14.5968 20.2251 15.3645 19.8267 16.0352C19.4325 16.6985 18.8821 17.2134 18.1885 17.5745C17.4909 17.9376 16.6941 18.1091 15.8167 18.1091H14.0405V20.1526C14.0405 20.5941 13.9251 21.0177 13.6377 21.3599L13.6365 21.3586C13.3236 21.7328 12.8815 21.8749 12.428 21.875C11.9684 21.875 11.5399 21.7158 11.2305 21.3477L11.2207 21.3354C10.9493 20.9962 10.8398 20.5833 10.8398 20.1526V11.0974C10.8398 10.6644 10.9463 10.2431 11.228 9.90479L11.2292 9.90601C11.5327 9.5329 11.9604 9.375 12.4158 9.375H15.8289ZM14.0405 15.3723H15.5481C16.1537 15.3723 16.5442 15.2081 16.8042 14.9536L16.9019 14.8474C17.1148 14.5894 17.2388 14.2408 17.2388 13.7537C17.2387 13.1862 17.0747 12.8079 16.8042 12.5427C16.5325 12.2765 16.1395 12.1118 15.5481 12.1118H14.0405V15.3723Z"
            fill="#FAEB49"
          />
          <defs>
            <linearGradient
              id={`paint0_linear_${uniqueId}`}
              x1="3"
              y1="3.5"
              x2="20"
              y2="23"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FAE14C" />
              <stop offset="1" stopColor="#D88304" />
            </linearGradient>
            <linearGradient
              id={`paint1_linear_${uniqueId}`}
              x1="22"
              y1="24.5"
              x2="6"
              y2="4"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFC445" />
              <stop offset="1" stopColor="#F59B1D" />
            </linearGradient>
          </defs>
        </svg>
      )}
      {variant === CoinIconVariant.DISABLED && serviceName === 'bubblechat' && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" fill={`url(#paint0_disabled_${uniqueId})`} />
          <mask
            id={`mask0_disabled_${uniqueId}`}
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="2"
            y="2"
            width="20"
            height="20"
          >
            <circle cx="12" cy="12" r="10" fill="white" />
          </mask>
          <g mask={`url(#mask0_disabled_${uniqueId})`}>
            <ellipse
              opacity="0.301438"
              cx="12"
              cy="8.25"
              rx="10"
              ry="6.25"
              fill={`url(#paint1_disabled_${uniqueId})`}
            />
          </g>
          <path
            d="M15.2077 10.832C14.5634 10.832 14.041 11.3544 14.041 11.9987C14.041 12.643 14.5634 13.1654 15.2077 13.1654C15.852 13.1654 16.3743 12.643 16.3743 11.9987C16.3743 11.3544 15.852 10.832 15.2077 10.832Z"
            fill={`url(#paint2_disabled_${uniqueId})`}
          />
          <path
            d="M8.79167 10.832C8.14734 10.832 7.625 11.3544 7.625 11.9987C7.625 12.643 8.14734 13.1654 8.79167 13.1654C9.43599 13.1654 9.95833 12.643 9.95833 11.9987C9.95833 11.3544 9.43599 10.832 8.79167 10.832Z"
            fill={`url(#paint3_disabled_${uniqueId})`}
          />
          <path
            d="M13.4577 11.998H10.541L10.5645 12.4505C10.6366 13.1437 11.26 13.6647 12.0084 13.6647C12.8087 13.6647 13.4577 13.0714 13.4577 12.3396V11.998Z"
            fill={`url(#paint4_disabled_${uniqueId})`}
          />
          <path
            d="M13.2002 12.2588C13.2 12.9212 12.6624 13.4579 12 13.458C11.3375 13.458 10.8 12.9213 10.7998 12.2588H13.2002ZM8.79688 11.0996C9.30608 11.0996 9.71956 11.5123 9.71973 12.0215C9.71973 12.5308 9.30618 12.9443 8.79688 12.9443C8.28772 12.9442 7.875 12.5307 7.875 12.0215C7.87516 11.5124 8.28782 11.0998 8.79688 11.0996ZM15.2178 11.0996C15.727 11.0996 16.1405 11.5123 16.1406 12.0215C16.1406 12.5308 15.7271 12.9443 15.2178 12.9443C14.7087 12.9441 14.2959 12.5306 14.2959 12.0215C14.2961 11.5125 14.7088 11.0998 15.2178 11.0996Z"
            fill="#999999"
          />
          <path
            d="M12 4.5C16.1355 4.5 19.5 7.86455 19.5 12C19.4999 16.1354 16.1354 19.5 12 19.5C10.8082 19.5 9.66593 19.2262 8.61133 18.6895C8.52031 18.6528 8.43837 18.6358 8.35156 18.6357C8.23311 18.6357 8.09763 18.6671 7.90234 18.7393L7.7998 18.7783L7.56836 18.875L6.89453 19.1689C6.81333 19.2009 6.72742 19.2227 6.64648 19.2227C6.33289 19.2226 6.07319 18.9873 6.03516 18.6797L6.03027 18.6006L6.03516 18.5439L6.06055 18.4053L6.18359 17.7773L6.22363 17.5498L6.25195 17.3623L6.26758 17.2158L6.27148 17.0928C6.26986 17.0248 6.26143 16.9671 6.24512 16.9121L6.21387 16.8291L6.16895 16.7402L6.11523 16.6465C5.05864 15.3103 4.50003 13.7038 4.5 12C4.5 7.86455 7.86448 4.5 12 4.5ZM12 5.33301C8.32471 5.33301 5.33301 8.32479 5.33301 12C5.33303 13.4214 5.76853 14.7625 6.59766 15.9043L6.76855 16.1299L6.83691 16.2314L6.91309 16.3652L6.95801 16.4541L6.99414 16.5371L7.04297 16.6738C7.07178 16.7707 7.09011 16.8686 7.09863 16.9883L7.10352 17.1162L7.09766 17.29L7.07617 17.4873L7.04395 17.6963L7.00098 17.9365L6.94141 18.2383L7.24805 18.1055L7.5 18.001L7.61328 17.957C7.89271 17.8538 8.11776 17.8027 8.35156 17.8027C8.54853 17.8028 8.73556 17.8417 8.98926 17.9473C9.92716 18.4245 10.9403 18.667 12 18.667C15.675 18.6668 18.666 15.6751 18.666 12C18.666 8.32489 15.6752 5.33317 12 5.33301Z"
            fill={`url(#paint5_disabled_${uniqueId})`}
          />
          <path
            opacity="0.351577"
            d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 2.41699C6.70728 2.41699 2.41701 6.70728 2.41699 12C2.41699 17.2927 6.70727 21.583 12 21.583C17.2927 21.583 21.583 17.2927 21.583 12C21.583 6.70732 17.2927 2.41705 12 2.41699Z"
            fill="#CCCCCC"
          />
          <defs>
            <linearGradient
              id={`paint0_disabled_${uniqueId}`}
              x1="2"
              y1="2"
              x2="2"
              y2="22"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FCFCFC" />
              <stop offset="0.0001" stopColor="#BFBFBF" />
              <stop offset="1" stopColor="#A6A6A6" />
            </linearGradient>
            <linearGradient
              id={`paint1_disabled_${uniqueId}`}
              x1="2"
              y1="2"
              x2="2"
              y2="14.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" stopOpacity="0.301857" />
              <stop offset="1" stopColor="#CCCCCC" />
            </linearGradient>
            <linearGradient
              id={`paint2_disabled_${uniqueId}`}
              x1="15.2077"
              y1="10.832"
              x2="15.2077"
              y2="13.1654"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#999999" />
              <stop offset="1" stopColor="#CCCCCC" />
            </linearGradient>
            <linearGradient
              id={`paint3_disabled_${uniqueId}`}
              x1="8.79167"
              y1="10.832"
              x2="8.79167"
              y2="13.1654"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#999999" />
              <stop offset="1" stopColor="#CCCCCC" />
            </linearGradient>
            <linearGradient
              id={`paint4_disabled_${uniqueId}`}
              x1="13.7179"
              y1="13.8318"
              x2="13.7179"
              y2="11.8677"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="1" stopColor="#999999" />
            </linearGradient>
            <linearGradient
              id={`paint5_disabled_${uniqueId}`}
              x1="19.9423"
              y1="19.2788"
              x2="19.9423"
              y2="7"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="1" stopColor="#999999" />
            </linearGradient>
          </defs>
        </svg>
      )}
      {variant === CoinIconVariant.DISABLED && serviceName === 'tingle' && (
        <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="2.43408" width="20" height="20" rx="10" fill={`url(#paint0_disabled_${uniqueId})`} />
          <rect x="2" y="2.43408" width="20" height="20" rx="10" stroke="#999999" strokeWidth="0.6" />
          <circle cx="12" cy="12.4341" r="8" fill={`url(#paint1_disabled_${uniqueId})`} />
          <path
            d="M9.94219 17.4341C9.69517 17.4341 9.5034 17.3528 9.36689 17.1903C9.23688 17.0278 9.17188 16.8165 9.17188 16.5565V9.31165C9.17188 9.04513 9.23688 8.83387 9.36689 8.67785C9.4969 8.51534 9.68542 8.43408 9.93244 8.43408H12.6627C13.2932 8.43408 13.8458 8.56084 14.3203 8.81436C14.7948 9.06138 15.1654 9.41241 15.4319 9.86745C15.6984 10.316 15.8317 10.8393 15.8317 11.4373C15.8317 12.0354 15.6984 12.5587 15.4319 13.0072C15.1654 13.4558 14.7948 13.8035 14.3203 14.0505C13.8458 14.2976 13.29 14.4211 12.6529 14.4211H10.732V16.5565C10.732 16.823 10.6637 17.0375 10.5272 17.2001C10.3972 17.3561 10.2022 17.4341 9.94219 17.4341ZM10.732 13.2315H12.4384C13.0169 13.2315 13.4687 13.0722 13.7938 12.7537C14.1253 12.4287 14.2911 11.9899 14.2911 11.4373C14.2911 10.8783 14.1253 10.4362 13.7938 10.1112C13.4622 9.78619 13.0104 9.62368 12.4384 9.62368H10.732V13.2315Z"
            fill="#CCCCCC"
            stroke="#CCCCCC"
          />
          <defs>
            <linearGradient
              id={`paint0_disabled_${uniqueId}`}
              x1="2.4"
              y1="3.23408"
              x2="16"
              y2="18.8341"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#D4D4D4" />
              <stop offset="1" stopColor="#A6A6A6" />
            </linearGradient>
            <linearGradient
              id={`paint1_disabled_${uniqueId}`}
              x1="17.6"
              y1="20.0341"
              x2="4.8"
              y2="3.63408"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#C0C0C0" />
              <stop offset="1" stopColor="#B0B0B0" />
            </linearGradient>
          </defs>
        </svg>
      )}
    </i>
  );
}

export default CoinIcon;
